/**
 * Created by Shikha on 2021-09-14.
 */

import {OktoberfestSymbol} from "./OktoberfestSymbol";
import {OktoberfestSymbolState} from "./OktoberfestSymbolConfig";
import {TimelineLite} from "gsap";
import {Oktoberfest} from "../Oktoberfest";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {OktoberfestSound} from "../sound/OktoberfestSound";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class OktoberfestScatter extends OktoberfestSymbol {
    private _landingAnimation: TimelineSprite;

    constructor(symbolName: string, reelId: number, initState: OktoberfestSymbolState) {
        super(symbolName, reelId, initState);
    }

    protected createState(state: OktoberfestSymbolState): void {
        super.createState(state);
        if (state === OktoberfestSymbolState.NO_WIN) {
            if(Oktoberfest.model.parsedGameData) {
                if (Oktoberfest.model.parsedGameData.mode !== GameMode.FREESPIN) {
                    if (this._landingAnimation) {
                        this._landingAnimation.tint = 0x555555
                    }
                }
            }
        }
        if (state === OktoberfestSymbolState.NORMAL) {
            if (this._landingAnimation) {
                this._landingAnimation.tint = 0xFFFFFF
            }
        }
    }

    public playLanding(): TimelineLite {
        if (!this._landingAnimation) {
            this._landingAnimation = new TimelineSprite(Oktoberfest.assetLoader.getTextures("S_att"));
            this._landingAnimation.anchor.set(0.5);
            this._landingAnimation.position.set(-8, -58);
            OktoberfestSound.soundPlayer.playTrack({name: OktoberfestSound.SOUND_NAME_SCATTER});
        }
        const landingTl: TimelineLite = new TimelineLite({paused: false});
        landingTl.add(this._landingAnimation.getAnimationAutoShowHide(true,false));

        const tl: TimelineLite = new TimelineLite();
        tl.add([
            () => this.updateLayers(),
            () => landingTl.play()
        ]);
        tl.to(this, {duration: this._landingAnimation.totalDuration});
        return tl;
    }

    protected updateLayers() {
        if (this._landingAnimation) {
            this.addChild(this._landingAnimation);
        }
    }

}